export enum CreateImageType {
  External = 'external',
  File = 'file',
  Import = 'import',
}
